import { ROLE_COLOR_MAP, ROLE_DETAILS } from "./data";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import { COMPACT_QUERY } from "../../utils/hooks/useCompact";

const compact = "@media " + COMPACT_QUERY;

interface RoleModalProps {
  open: boolean;
  onClose: () => void;
}

export default function RoleModal({ open, onClose }: RoleModalProps) {
  return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "800px",
            width: "100%",
            padding: 0,
            [compact]: { maxHeight: "94vh" },
          },
        },
      }}
    >
      <DialogTitle sx={{ padding: "16px" }}>สิทธิ์การใช้งาน</DialogTitle>
      <DialogContent
        sx={{ width: "100%", padding: "0", [compact]: { overflowY: "auto" } }}
      >
        <TableContainer sx={{ padding: "0" }}>
          <Table>
            <TableHead
              sx={{
                bgcolor: (theme) => theme.palette.background.default,
                padding: "4px",
              }}
            >
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: (theme) =>
                      `1px solid ${theme.palette.draft.main}`,
                  }}
                >
                  ชื่อสิทธิ์
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: (theme) =>
                      `1px solid ${theme.palette.draft.main}`,
                  }}
                >
                  คำอธิบาย
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ROLE_DETAILS.map(({ role, description }, index) => (
                <TableRow
                  key={role}
                  sx={{
                    bgcolor: index % 2 === 1 ? "#f6f6f9" : "#fff",
                    "& td, & th": { padding: "12px" },
                  }}
                >
                  <TableCell>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Chip
                        key={role}
                        label={role}
                        variant="outlined"
                        color="primary"
                        sx={{
                          width: "100%",
                          textTransform: "capitalize",
                          borderColor: ROLE_COLOR_MAP[role],
                          color: ROLE_COLOR_MAP[role],
                        }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell>{description}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions sx={{ padding: "16px" }}>
        <Button variant="contained" onClick={onClose}>
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
